import { loadImagePromise, ratio } from "../../helpers/UtilFunctions";

export async function refill(imageswithprops: any[] = [], stacks: any[] = [], img: any = null, imagearray: any[] = []) {

    for (let image of imagearray) {
        img = await loadImagePromise(image.imageUrl);
        if (img) imageswithprops.push({
            ...image, ratio: ratio(img.width, img.height), width: img.width,
            height: img.height
        });
    }



    for (let i = 0; i < imagearray.length; i++) {
        if (!imageswithprops[i]) break;

        //Si la forma es cuadrada
        if (imageswithprops[i].ratio > 0.9 && imageswithprops[i].ratio <= 1.1) {
            stacks.push([...[imageswithprops[i]]]);

            //Si la forma es cuadrada pero es una imagen pequeña
        } else if (imageswithprops[i].ratio > 1.1 && imageswithprops[i].width < 1000) {
            if (imageswithprops[i + 1]) {
                if (imageswithprops[i + 1].ratio > 1.1 && imageswithprops[i + 1].width < 1000) {
                    stacks.push([...[imageswithprops[i]], ...[imageswithprops[i + 1]]]);
                    i++;
                } else {
                    stacks.push([...[imageswithprops[i]]]);
                }
            } else {
                stacks.push([...[imageswithprops[i]]]);
                break;
            }

            // Si la imagen es grande
        } else if (imageswithprops[i].width >= 1000) {
            stacks.push([...[imageswithprops[i]]]);

            // Si la imagen es vertical
        } else if (imageswithprops[i].ratio <= 0.9) {

            if (imageswithprops[i + 1]) {
                if (imageswithprops[i + 1].ratio <= 0.9) {
                    stacks.push([...[imageswithprops[i]], ...[imageswithprops[i + 1]]]);
                    i++;
                } else if (imageswithprops[i + 1].ratio > 0.9) {
                    if (imageswithprops[i + 2]) {
                        if (imageswithprops[i + 2].ratio > 0.9) {
                            stacks.push([...[imageswithprops[i]], ...[imageswithprops[i + 1]], ...[imageswithprops[i + 2]]]);
                            i += 2;
                        } else {
                            stacks.push([...[imageswithprops[i]]]);
                        }
                    } else {
                        stacks.push([...[imageswithprops[i]]]);
                    }
                }
            } else {
                stacks.push([...[imageswithprops[i]]]);
                break;
            }
        }
    }

    return stacks;
}

/* const imagesgs = [
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-553484285595648424/original/999051af-a099-42db-b108-3e6bff8888cd.jpeg?im_w=1200'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-553484285595648424/original/ab3c1339-741f-4733-b35b-31d26e9df4d6.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-553484285595648424/original/ab3c1339-741f-4733-b35b-31d26e9df4d6.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-49962064/original/3eb6482a-5abe-4eb9-bdf8-e8f822d84cfb.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-49962064/original/5c91ce99-fc43-4a4f-b872-a043d0c446a0.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-49962064/original/5c91ce99-fc43-4a4f-b872-a043d0c446a0.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/2d4fd984-c855-4f9e-a30e-76188718a566.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/b5584205-ef7b-4eb3-9a72-f68b71fbd2c7.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/71c565d7-a507-442f-a2b5-24ad70a062af.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/27200228-a357-4b94-b8c0-d5bb98339c2e.jpeg?im_w=1200'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/8b6d9487-afe0-4626-b846-c2d5c32ee0d9.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/0267d09d-e75c-4058-8c8b-d64b9688c36b.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/43b73378-a22a-47ce-98ad-4eaacfb91d6e.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/366ebce6-e8da-4e4d-897e-e1c11217b8d4.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/72da7922-9715-4c47-a04e-361df05697a3.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/50e8ae65-b675-4b32-a9b3-7780a2886262.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/79893cc3-672c-4187-92e6-b32948b0eea7.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-50796582/original/383e1b64-962b-4407-955b-e3c47bd1ae23.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-39039184/original/12002638-81bc-4c58-9d36-42be965c4726.jpeg?im_w=1200'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/a7d45921-ef88-4336-812e-8bcaaaef2f54.jpg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-39039184/original/d360c95c-1630-4d24-9400-7ee404f7e77a.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-39039184/original/0e7c7375-5c65-4ee2-8cc7-ee924a3adef7.jpeg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/miso/Hosting-39039184/original/d9c22479-7fbf-4175-9784-c3dc94064363.jpeg?im_w=1200'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/905ab74b-79e7-4358-8fdc-854af2b45b68.jpg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/9b0b9788-8544-4d71-8740-0ddd8548c3d4.jpg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/560b05f3-967b-48ff-80a1-ec4c05cbf67a.jpg?im_w=720'
    },
    {
        imageUrl: 'https://a0.muscache.com/im/pictures/2dcbfaf2-5cd0-40e0-8db5-1828aa0b0db4.jpg?im_w=720'
    }

]; */